<template>
    <div class="card-contact-details">
        <button type="button" class="card-contact-details__cta-master" @click="setAvailability()">
            <common-icon name="calendar" size="gigantic"></common-icon>

            <p>
                <span>{{ $t('elements.referrals.card.availability_not_set') }}</span>
                <em>{{ $t('elements.referrals.card.set_availability_now') }}</em>
            </p>
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            physician: { type: Object, required: true },
        },

        methods: {
            setAvailability() {
                this.$auth.setActiveMember(this.physician)
                this.$router.push({ name: 'auth.signup.schedule' })
            },
        },
    }
</script>
